import React from 'react';
import { getLevelInfo } from '../../utils/reputationSystem';

/**
 * Component แสดง Level Badge
 * @param {number} level - Level (1-5)
 * @param {number} score - คะแนน (optional)
 * @param {string} type - 'profile' หรือ 'store' (optional)
 */
const LevelBadge = ({ level, score = null, type = 'profile' }) => {
  if (!level || level < 1 || level > 5) {
    return null;
  }
  
  const levelInfo = getLevelInfo(level);
  const levelNames = {
    1: '🥉',
    2: '🥈',
    3: '🥇',
    4: '💎',
    5: '💠'
  };
  
  return (
    <div 
      className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold"
      style={{ 
        backgroundColor: `${levelInfo.color}20`,
        color: levelInfo.color,
        border: `1px solid ${levelInfo.color}40`
      }}
    >
      <span className="mr-1">{levelNames[level]}</span>
      <span>{levelInfo.name}</span>
      {score !== null && (
        <span className="ml-1 text-gray-600">({score})</span>
      )}
    </div>
  );
};

export default LevelBadge;














